import _defineProperty from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "/home/node/app/node_modules/next/node_modules/@babel/runtime/regenerator";
import axios from 'axios';
import config from "../utils/clientConfig";
var initialState = {};
var actionTypes = {
  GET_OFFERS: 'GET_OFFERS',
  GET_OFFERS_SUCCESS: 'GET_OFFERS_SUCCESS'
};
export var getOffersFromAPI = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var channel, limit, accessToken, options, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            channel = _ref.channel, limit = _ref.limit, accessToken = _ref.accessToken;
            options = {
              method: 'POST',
              headers: {
                Authorization: "Basic ".concat(accessToken)
              },
              url: "".concat(config.OFFERS_API_BASE, "?channel=").concat(channel, "&pageSize=").concat(limit)
            };
            _context.next = 4;
            return axios(options);
          case 4:
            result = _context.sent;
            return _context.abrupt("return", result.data);
          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getOffersFromAPI(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var getOffers = function getOffers(channel, limit) {
  return function (dispatch, getState) {
    var _getState = getState(),
      accessToken = _getState.user.accessToken,
      offers = _getState.offers;
    if (offers[channel] === 'LOADING' || !accessToken) {
      return;
    }
    dispatch({
      type: actionTypes.GET_OFFERS,
      channel: channel
    });
    getOffersFromAPI({
      channel: channel,
      limit: limit,
      accessToken: accessToken
    }).then(function (offers) {
      dispatch({
        type: actionTypes.GET_OFFERS_SUCCESS,
        offers: offers,
        channel: channel
      });
    });
  };
};
export var offersReducer = function offersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var stateClone = _objectSpread({}, state);
  switch (action.type) {
    case actionTypes.GET_OFFERS:
      stateClone[action.channel] = 'LOADING';
      return stateClone;
    case actionTypes.GET_OFFERS_SUCCESS:
      stateClone[action.channel] = action.offers;
      return stateClone;
    default:
      return state;
  }
};